import styled from 'styled-components';
import { darken, lighten } from 'polished';

export const Container = styled.section`
  flex: 1;
  display: flex;
  min-width: 300px;
  gap: 5px;
  padding: 5px;
  border-radius: ${({ theme }) => theme.metrics.radius};
  background-color: ${({ theme }) => darken(0.05, theme.colors.background)};
`;

export const Grade = styled.div`
  min-width: 300px;
  width: 300px;
  display: flex;
  flex-direction: column;
  border-radius: ${({ theme }) => theme.metrics.radius};
  background-color: ${({ theme }) => lighten(0.01, theme.colors.background)};

  @media (max-width: ${({ theme }) => theme.metrics.tablet_small}) {
    min-width: 275px;
    min-width: 100%;
  }
`;

export const GradeHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => theme.metrics.padding};
  border-top-left-radius: ${({ theme }) => theme.metrics.radius};
  border-top-right-radius: ${({ theme }) => theme.metrics.radius};
  background-color: ${({ theme }) => theme.colors.primary};
`;

export const GradeTitulo = styled.h4`
  margin-left: ${({ theme }) => theme.metrics.margin};
  font-size: 16px;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const GradeBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.metrics.gap};
  padding: ${({ theme }) => theme.metrics.padding};
  border-bottom-left-radius: ${({ theme }) => theme.metrics.radius};
  border-bottom-right-radius: ${({ theme }) => theme.metrics.radius};
  background-color: ${({ theme }) => lighten(0.01, theme.colors.background)};
`;

export const HeaderButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  border: none;
  border-radius: ${({ theme }) => theme.metrics.radius};
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.textPrimary};

  &:hover {
    background-color: ${({ theme }) => darken(0.05, theme.colors.primary)};
  }
`;
